/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";

/**
 * Report store
 */
window.$(".saveSchedule").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveSchedule').attr('disabled', 'disabled');
    window.axios({
            method: "post",
            url: window.$(".scheduleForm").attr('action'),
            data: window.$(".scheduleForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function(error) {
            window.$('.saveSchedule').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Report update
 */
window.$(".updateSchedule").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateSchedule').attr('disabled', 'disabled');
    window.axios({
            method: "PUT",
            url: window.$(".scheduleUpdateForm").attr('action'),
            data: window.$(".scheduleUpdateForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.updateSchedule').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});
